import { useState } from 'react';
import Button from '../Button/Button';
import { ClickableAction, ClickableTarget } from '../Clickable/consts';
import type { FormFieldElement } from '../FormField/interfaces';
import FormFieldSuggestion from '../FormFieldSuggestion/FormFieldSuggestion';
import type { SuggestionOption } from '../FormFieldSuggestion/interfaces';
import {
  dataToOptions,
  filterOptions,
  findSelectedOptionValue,
} from './helpers';
import { useSmartChargingBrands } from './hooks/useSmartChargingBrands';
import styles from './SmartChargingAppSelector.module.scss';

const initialState = { inputValue: '', selected: '' };

const SmartChargingAppSelector = () => {
  const [brand, setBrand] = useState(initialState);
  const brands = useSmartChargingBrands();
  const brandOptions = dataToOptions(brands.data);
  const brandSuggestions = filterOptions(brand.inputValue, brandOptions);

  const onChange = (event: React.ChangeEvent<FormFieldElement>) => {
    const value = event.target.value;
    setBrand({
      inputValue: value,
      selected: findSelectedOptionValue(value, brandOptions) ?? '',
    });
  };

  const onSelectOption = (option: SuggestionOption) => {
    setBrand({ inputValue: option.label, selected: option.value });
  };

  return (
    <div className={styles.base}>
      <div className={styles.fields}>
        <FormFieldSuggestion
          inputId="car-brand"
          label="Hersteller Ihres Fahrzeugs"
          options={brandSuggestions}
          nativeOptions={brandSuggestions}
          onChange={onChange}
          value={brand.inputValue}
          name="brand"
          onSelectOption={onSelectOption}
          disableNativeSelect
        />
      </div>
      {brand.selected && (
        <div className={styles.buttons}>
          <Button
            actionType={ClickableAction.Linkextern}
            linkextern="https://apps.apple.com/de/app/enercity-smartladen/id6745022257"
            target={ClickableTarget.Blank}
          >
            Für iOS (Apple) herunterladen
          </Button>
          <Button
            actionType={ClickableAction.Linkextern}
            linkextern="https://play.google.com/store/apps/details?id=de.enercity.smartcharging"
            target={ClickableTarget.Blank}
          >
            Für Android herunterladen
          </Button>
        </div>
      )}
    </div>
  );
};

export default SmartChargingAppSelector;
